module.exports = __webpack_public_path__ + "img/image42.2780b1ce.png";